import { render, staticRenderFns } from "./adjustingSubsidiesModal.vue?vue&type=template&id=33d161b4&scoped=true"
import script from "./adjustingSubsidiesModal.vue?vue&type=script&lang=js"
export * from "./adjustingSubsidiesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d161b4",
  null
  
)

export default component.exports